"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How can a navigator help me understand my diagnosis?",
  answer: "I provide one-on-one consultations to translate complex pathology reports, biopsy results, and PSA trends into clear, understandable language. Our goal is to ensure you fully grasp your specific staging and risk classification before making any major decisions."
}, {
  question: "What treatment options do you help patients explore?",
  answer: "I guide you through the full spectrum of care, including active surveillance, surgery, radiation, focal therapy, and systemic treatments. I focus on how each path may impact your quality of life—including urinary and sexual health—so you can choose the option that aligns with your personal goals."
}, {
  question: "Can you help me prepare for my oncology appointments?",
  answer: "Yes. We assist you in organizing your medical history and developing a list of meaningful, targeted questions for your urologists and radiation oncologists. This preparation ensures you maximize your time with your care team and get the answers you need."
}, {
  question: "Do you offer support for family members and caregivers?",
  answer: "Absolutely. I offer dedicated support for spouses and family members, helping them understand the diagnosis and providing guidance on how to best support their loved one through the emotional and physical challenges of the decision-making and treatment process."
}, {
  question: "When is genomic or germline testing appropriate?",
  answer: "I help clarify when tests like PHI, SelectMDx, or tissue-based genomic assays are necessary. Our team explains what the results mean for your prognosis and how they might influence your specific treatment plan or surveillance strategy."
}];
export default function DentalExcellenceFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="85689" id="common-family-questions" className="bg-background text-foreground py-24 md:py-32 lg:py-40">
      <div ref={ref} className={`container mx-auto max-w-3xl px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-16 text-center">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-primary tracking-tight mb-4">
            Common Family Questions
          </h2>
          <p className="font-sans text-muted-foreground text-lg max-w-xl mx-auto">
            Find clarity and professional guidance as you navigate the complexities of a prostate cancer diagnosis.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full shadow-sm rounded-3xl bg-card/30 p-2 border border-border/20">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/40 px-4">
              <AccordionTrigger className="font-sans font-bold text-[18px] md:text-[20px] text-foreground hover:no-underline hover:text-accent-foreground transition-colors text-left py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent>
                <div className="border-l-[3px] border-secondary/40 pl-6 py-2 mb-6 font-sans text-base text-muted-foreground leading-relaxed">
                  {faq.answer}
                </div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}